import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    setFullPageLayout: ['payload'],
    setStep: ['payload'],
    addFile: ['payload'],
    addFile2: ['payload'],
    removeFile: null,
    removeFile2: null,
    reset: null,
    saveEstimationDataRequest: ['payload', 'data'],
    saveEstimationDataSuccess: ['payload'],
    saveEstimationDataFailure: null,
    setParsingProgress: ['payload'],
    setParsingState: ['payload'],
    setGlobalDownloadData: ['payload'],
    clearGlobalDownloadData: null,
  },
  { prefix: 'ESTIMATION_SHEET_IMPORT/' },
);

export default Creators;
